import { Navigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getStoredToken } from "../api/client";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute() {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="godo-app-bg flex min-h-screen items-center justify-center">
        <p className="text-sm text-slate-500">{t("labels.loading_session")}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export function GuestRoute() {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth();
  const hasStoredSession = Boolean(getStoredToken());

  if (isLoading && hasStoredSession) {
    return (
      <div className="godo-app-bg flex min-h-screen items-center justify-center">
        <p className="text-sm text-slate-500">{t("labels.loading")}</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
